import { Language, TemplateSubType, TemplateType } from '../../../types/dto-app';

export const leaseTerminationTemplates = [
  {
    id: '-125001',
    language: Language.EN,
    subject: 'End of lease date updated',
    type: TemplateType.MAIL,
    subType: TemplateSubType.LEASE_TERMINATION,
    clientId: 'Template#-1',
    readId: 'R#Template#-1',
    body: `
        <p>Dear {{listAllTenants lease}},</p>
        <p></p>
        <p>Subject: Updating the end date of the lease located <strong>{{getLeaseMainAddress lease}}</strong>, signed on {{formatDate lease.signatureDate}} and having started on {{formatDate lease.startDate}}.</p>
        <p></p>
        <p>We regret to inform you that your lease will be ending on: <strong>{{formatDate lease.endDate}}</strong>.</p>
        <p></p>
        {{#if (isRegion lease "Wallonia")}}
        {{#if (isShortTerms lease)}}
        <p>We hereby inform you of our wish to terminate the lease on the above-mentioned date, in accordance with Article 55 § 6 of the Walloon Decree of 15 March 2018 on residential leases.</p>
        {{else}}
        <p>We hereby inform you of our wish to terminate the lease on the above-mentioned date, in accordance with Article 55 § 1 of the Walloon Decree of 15 March 2018 on residential leases.</p>
        {{/if}}
        {{/if}}
        {{#if (isRegion lease "Brussels")}}
        {{#if (isShortTerms lease)}}
        <p>We hereby inform you of our wish to terminate the lease on the above-mentioned date, in accordance with paragraph 4 of Article 238 of the Brussels Housing Code.</p>
        {{else}}
        <p>We hereby inform you of our wish to terminate the lease on the above-mentioned date, in accordance with Article 237,1§ of the Brussels Housing Code.</p>
        {{/if}}
        {{/if}}
        {{#if (isRegion lease "Flanders")}}
        {{#if (isShortTerms lease)}}
        <p>We hereby inform you of our wish to terminate the lease on the above-mentioned date, in accordance with paragraph 2 of Article 21 of the Flemish Decree on Residential Tenancies (Vlaamse Woonhuurdecreet).</p>
        {{else}}
        <p>We hereby inform you of our wish to terminate the lease on the above-mentioned date, in accordance with paragraph 2 of Article 16 of the Flemish Decree on Residential Tenancies (Vlaamse Woonhuurdecreet).</p>
        {{/if}}
        {{/if}}
        {{#if (isForOwnUse leaseActionHistory)}}
        <p>We wish to occupy the premises for personal use. The premises will be occupied by {{leaseActionHistory.endReasonOwnUseRelation}}, hereinafter referred to as {{leaseActionHistory.endReasonOwnUseName}}.</p>
        {{/if}}
        {{#if (isForRenovation leaseActionHistory)}}
        <p>We wish to carry out major works on the premises that will require your departure. You will find attached the documents justifying our wish to carry out the work.</p>
        {{/if}}
        {{#if (hasComment leaseActionHistory)}}
        <p></p>
        <p>{{leaseActionHistory.comment}}</p>
        {{/if}}
        <p></p>
        <p>Kind regards,</p>
        <p></p>
        <p>{{signature lease}}</p>
        `,
  },
  {
    id: '-125002',
    language: Language.FR,
    subject: 'Mise à jour de la date de fin du bail',
    type: TemplateType.MAIL,
    subType: TemplateSubType.LEASE_TERMINATION,
    clientId: 'Template#-1',
    readId: 'R#Template#-1',
    body: `
        <p>Cher/Chère {{listAllTenants lease}},</p>
        <p></p>
        <p>Concerne: Mise à jour de la date de fin du bail sis <strong>{{getLeaseMainAddress lease}}</strong>, signé le {{formatDate lease.signatureDate}} et ayant pris cours le {{formatDate lease.startDate}}.</p>
        <p></p>
        <p>Nous sommes au regret de vous annoncer que votre bail prendra fin le: <strong>{{formatDate lease.endDate}}</strong>.</p>
        <p></p>
        {{#if (isRegion lease "Wallonia")}}
        {{#if (isShortTerms lease)}}
        <p>Par la présente, nous vous informons notre volonté de mettre fin au bail à la date susmentionnée, conformément à l'article 55 § 6 du décret wallon du 15 mars 2018 relatif au bail d'habitation.</p>
        {{else}}
        <p>Par la présente, nous vous informons notre volonté de mettre fin au bail à la date susmentionnée, conformément à l'article 55 § 1er du décret wallon du 15 mars 2018 relatif au bail d'habitation.</p>
        {{/if}}
        {{/if}}
        {{#if (isRegion lease "Brussels")}}
        {{#if (isShortTerms lease)}}
        <p>Par la présente, nous vous informons notre volonté de mettre fin au bail à la date susmentionnée, conformément au paragraphe 4 de l'article 238 du Code bruxellois du Logement.</p>
        {{else}}
        <p>Par la présente, nous vous informons notre volonté de mettre fin au bail à la date susmentionnée, conformément à l'article 237,1§ du Code bruxellois du Logement.</p>
        {{/if}}
        {{/if}}
        {{#if (isRegion lease "Flanders")}}
        {{#if (isShortTerms lease)}}
        <p>Par la présente, nous vous informons notre volonté de mettre fin au bail à la date susmentionnée, conformément au paragraphe 2 de l'article 21 du Décret flamand sur la location d'habitation.</p>
        {{else}}
        <p>Par la présente, nous vous informons notre volonté de mettre fin au bail à la date susmentionnée, conformément au paragraphe 2 de l'article 16 du Décret flamand sur la location d'habitation.</p>
        {{/if}}
        {{/if}}
        {{#if (isForOwnUse leaseActionHistory)}}
        <p>Nous souhaitons occuper les lieux pour un usage personnel. Le lieu sera occupé par {{leaseActionHistory.endReasonOwnUseRelation}}, ci-nommé {{leaseActionHistory.endReasonOwnUseName}}.</p>
        {{/if}}
        {{#if (isForRenovation leaseActionHistory)}}
        <p>Nous souhaitons réaliser des travaux importants dans les lieux qui vont nécessiter votre départ. Vous trouverez en annexe les documents justifiant notre souhait de réaliser les travaux.</p>
        {{/if}}
        {{#if (hasComment leaseActionHistory)}}
        <p></p>
        <p>{{leaseActionHistory.comment}}</p>
        {{/if}}
        <p></p>
        <p>Bien à vous,</p>
        <p></p>
        <p>{{signature lease}}</p>
        `,
  },
  {
    id: '-125003',
    language: Language.NL,
    subject: 'De einddatum van uw huurcontract werdt aangepast',
    type: TemplateType.MAIL,
    subType: TemplateSubType.LEASE_TERMINATION,
    clientId: 'Template#-1',
    readId: 'R#Template#-1',
    body: `
        <p>Beste {{listAllTenants lease}},</p>
        <p></p>
        <p>Onderwerp: De einddatum van de huurovereenkomst gelegen <strong>{{getLeaseMainAddress lease}}</strong>, ondertekend {{formatDate lease.signatureDate}} en die op {{formatDate lease.startDate}} inging.</p>
        <p></p>
        <p>Tot onze spijt moeten wij u mededelen dat uw huurcontract op <strong>{{formatDate lease.endDate}}</strong> zal aflopen.</p>
        <p></p>
        {{#if (isRegion lease "Wallonia")}}
        {{#if (isShortTerms lease)}}
        <p>Hierbij brengen wij u op de hoogte van onze wens om de huurovereenkomst op bovengenoemde datum te beëindigen, in overeenstemming met artikel 55 § 6 van het Waalse decreet van 15 maart 2018 inzake woninghuur.</p>
        {{else}}
        <p>Hierbij brengen wij u op de hoogte van onze wens om de huurovereenkomst op bovengenoemde datum te beëindigen, in overeenstemming met artikel 55 § 1 van het Waalse decreet van 15 maart 2018 inzake woninghuur.</p>
        {{/if}}
        {{/if}}
        {{#if (isRegion lease "Brussels")}}
        {{#if (isShortTerms lease)}}
        <p>Hierbij brengen wij u op de hoogte van onze wens om de huurovereenkomst op bovengenoemde datum te beëindigen, in overeenstemming met paragraaf 4 van artikel 238 van de Brusselse Woningcode</p>
        {{else}}
        <p>Wij brengen u hierbij op de hoogte van onze wens om de huurovereenkomst op te zeggen op bovengenoemde datum, overeenkomstig artikel 237,1§ van de Brusselse Woningcode.</p>
        {{/if}}
        {{/if}}
        {{#if (isRegion lease "Flanders")}}
        {{#if (isShortTerms lease)}}
        <p>Hierbij brengen wij u op de hoogte van onze wens om de huurovereenkomst op te zeggen op bovengenoemde datum, overeenkomstig paragraaf 2 van artikel 21 van het Vlaamse Woninghuurdecreet.</p>
        {{else}}
        <p>Hierbij brengen wij u op de hoogte van onze wens om de huurovereenkomst op te zeggen op bovengenoemde datum, overeenkomstig paragraaf 2 van artikel 16 van het Vlaamse Woninghuurdecreet.</p>
        {{/if}}
        {{/if}}
        {{#if (isForOwnUse leaseActionHistory)}}
        <p>Wij willen het pand in gebruik nemen voor persoonlijk gebruik. Het pand zal worden bewoond door {{leaseActionHistory.endReasonOwnUseRelation}}, hierna {{leaseActionHistory.endReasonOwnUseName}} genoemd.</p>
        {{/if}}
        {{#if (isForRenovation leaseActionHistory)}}
        <p>Wij willen grote werkzaamheden aan het pand uitvoeren waarvoor u het pand moet verlaten. Bijgevoegd vindt u de documenten die onze wens om de werkzaamheden uit te voeren rechtvaardigen.</p>
        {{/if}}
        {{#if (hasComment leaseActionHistory)}}
        <p></p>
        <p>{{leaseActionHistory.comment}}</p>
        {{/if}}
        <p></p>
        <p>Met vriendelijke groeten,</p>
        <p></p>
        <p>{{signature lease}}</p>
        `,
  },
  {
    id: '-125004',
    language: Language.DE,
    subject: 'Enddatum des Mietvertrags aktualisiert',
    type: TemplateType.MAIL,
    subType: TemplateSubType.LEASE_TERMINATION,
    clientId: 'Template#-1',
    readId: 'R#Template#-1',
    body: `
        <p>Sehr geehrte/r {{listAllTenants lease}},</p>
        <p></p>
        <p>Betreff: Aktualisierung des Enddatums des Mietvertrags für die Immobilie in <strong>{{getLeaseMainAddress lease}}</strong>, unterzeichnet am {{formatDate lease.signatureDate}} und begonnen am {{formatDate lease.startDate}}.</p>
        <p></p>
        <p>Wir bedauern, Ihnen mitteilen zu müssen, dass Ihr Mietvertrag am <strong>{{formatDate lease.endDate}}</strong> enden wird.</p>
        <p></p>
        {{#if (isRegion lease "Wallonia")}}
        {{#if (isShortTerms lease)}}
        <p>Hiermit teilen wir Ihnen unseren Wunsch mit, den Mietvertrag zum oben genannten Datum zu beenden, gemäß Artikel 55 § 6 des wallonischen Dekrets vom 15. März 2018 über Wohnungsmiete.</p>
        {{else}}
        <p>Hiermit teilen wir Ihnen unseren Wunsch mit, den Mietvertrag zum oben genannten Datum zu beenden, gemäß Artikel 55 § 1 des wallonischen Dekrets vom 15. März 2018 über Wohnungsmiete.</p>
        {{/if}}
        {{/if}}
        {{#if (isRegion lease "Brussels")}}
        {{#if (isShortTerms lease)}}
        <p>Hiermit teilen wir Ihnen unseren Wunsch mit, den Mietvertrag zum oben genannten Datum zu beenden, gemäß Absatz 4 von Artikel 238 des Brüsseler Wohnungsgesetzbuchs.</p>
        {{else}}
        <p>Hiermit teilen wir Ihnen unseren Wunsch mit, den Mietvertrag zum oben genannten Datum zu beenden, gemäß Artikel 237,1§ des Brüsseler Wohnungsgesetzbuchs.</p>
        {{/if}}
        {{/if}}
        {{#if (isRegion lease "Flanders")}}
        {{#if (isShortTerms lease)}}
        <p>Hiermit teilen wir Ihnen unseren Wunsch mit, den Mietvertrag zum oben genannten Datum zu beenden, gemäß Absatz 2 von Artikel 21 des Flämischen Wohnungsmietdekrets.</p>
        {{else}}
        <p>Hiermit teilen wir Ihnen unseren Wunsch mit, den Mietvertrag zum oben genannten Datum zu beenden, gemäß Absatz 2 von Artikel 16 des Flämischen Wohnungsmietdekrets.</p>
        {{/if}}
        {{/if}}
        {{#if (isForOwnUse leaseActionHistory)}}
        <p>Wir möchten die Räumlichkeiten für den Eigengebrauch nutzen. Die Räumlichkeiten werden von {{leaseActionHistory.endReasonOwnUseRelation}}, nachstehend {{leaseActionHistory.endReasonOwnUseName}} genannt, bewohnt werden.</p>
        {{/if}}
        {{#if (isForRenovation leaseActionHistory)}}
        <p>Wir möchten umfangreiche Renovierungsarbeiten an den Räumlichkeiten durchführen, die Ihren Auszug erfordern. Im Anhang finden Sie die Dokumente, die unseren Wunsch zur Durchführung der Arbeiten rechtfertigen.</p>
        {{/if}}
        {{#if (hasComment leaseActionHistory)}}
        <p></p>
        <p>{{leaseActionHistory.comment}}</p>
        {{/if}}
        <p></p>
        <p>Mit freundlichen Grüßen,</p>
        <p></p>
        <p>{{signature lease}}</p>
        `,
  },
];
